/** bodyType ids for "Reboque" (10) and "Semi-reboque" (11) — see bodyTypeMap. */
export const TRAILER_BODY_TYPE_IDS = new Set([10, 11]);
